import { PROJECTS_RECEIVED_GET_ALERT_CONFIGURATIONS } from '../../legacy/actions/project-actions';
import { legacyFulfill } from '../utils';
import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export type AlertSetting = {
  id: number;
  alert_configuration_id: number;
  alert_subtype: string;
  low_warning_threshold: number | null;
  low_alert_threshold: number | null;
  high_warning_threshold: number | null;
  high_alert_threshold: number | null;
  time_periods_warning: number | null;
  time_periods_alert: number | null;
  function_warning?: string | null;
  function_alert?: string | null;
  [key: string]: unknown;
};

export type AlertConfiguration = {
  id: number;
  name: string;
  description: string;
  client_id: number;
};

export type AlertConfigurationsResponse = {
  alert_configurations: AlertConfiguration[];
  alert_settings: AlertSetting[];
};

export type AlertConfigurationPayload = {
  asset_template_id: number;
  alert_configuration: Omit<AlertConfiguration, 'id'> | AlertConfiguration;
  alert_settings: Array<Partial<AlertSetting>>;
};

export type UpdateAlertConfigurationPayload = AlertConfigurationPayload & {
  alert_configuration: AlertConfiguration;
};

export const alertConfigurationsApi = (builder: BuilderType) => ({
  getAlertConfigurations: builder.query<AlertConfigurationsResponse, void>({
    query: () => `service/alert-configurations`,
    providesTags: [projectsCacheTags.ALERT_CONFIGURATIONS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_GET_ALERT_CONFIGURATIONS),
  }),

  createAlertConfiguration: builder.mutation<AlertConfigurationPayload, AlertConfigurationPayload>({
    query: (config) => ({
      url: `service/alert-configurations`,
      method: 'POST',
      body: config,
    }),
    invalidatesTags: [projectsCacheTags.ALERT_CONFIGURATIONS, projectsCacheTags.FLEETS],
  }),

  updateAlertConfiguration: builder.mutation<AlertConfigurationPayload, UpdateAlertConfigurationPayload>({
    query: (config) => ({
      url: `service/alert-configurations/${config.alert_configuration.id}`,
      method: 'PUT',
      body: config,
    }),
    invalidatesTags: [projectsCacheTags.ALERT_CONFIGURATIONS, projectsCacheTags.FLEETS],
  }),
});
